<template>
  <div class="submitLookingSite">
    <img src="/static/images/success.jpg" />
    <div class="m-t10 fs17" style="color: #0ca309">评价成功</div>

    <div class="m-t25">您评价已收到</div>
    <div class="m-t10">感谢您的信任与支持</div>

    <van-button plain color="#0ca309" size="small" @click="toHome()"
      >完成</van-button
    >
  </div>
</template>

<script>
import { Button } from "vant";

export default {
  components: {
    [Button.name]: Button,
  },
  data() {
    return {};
  },
  methods: {
    //跳转首页
    toHome() {
      this.$router.push({ path: "/order/index" });
    },
  },
};
</script>

<style lang="less" scoped>
.submitLookingSite {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 50px 0px;
  font-size: 14px;

  .van-button {
    width: 150px;
    font-size: 14px;
    position: absolute;
    bottom: 50px;
    border-radius: 4px;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/order/evaluateFinish.vue